import { CustomBottomBar } from '@components';
import { Button, Checkbox, Container, Textarea, Typography } from '@design-system';
import './WorksitePresentationPage.scss';
import { useWorksitePresentationPageVM } from './useWorksitePresentationPageVM';

export const WorksitePresentationPage: React.FC = () => {
    const {
        handleNext,
        steps,
        handleSetCheckbox,
        isConsignesParticulieresChecked,
        worksitePresentationComment,
        setWorksitePresentationComment
    } = useWorksitePresentationPageVM();

    return (
        <div className="worksite-presentation-page">
            <Container>
                <Typography intrinsic="h2">{steps[0].label}</Typography>
            </Container>

            <Container className="pt-none">
                <Container className="worksite-presentation-checkboxes" bordered="grey" padding="medium large">
                    <Typography intrinsic="h3" className="mb-small-medium-spacing">
                        Liste des points à présenter
                    </Typography>
                    {steps[0].checkboxes?.map((checkbox, index) => (
                        <Checkbox
                            key={checkbox.label}
                            label={checkbox.label}
                            checked={checkbox.isChecked}
                            onChange={(checked) => handleSetCheckbox(0, index, checked)}
                        />
                    ))}
                    {isConsignesParticulieresChecked && (
                        <Textarea
                            value={worksitePresentationComment}
                            onValueChange={setWorksitePresentationComment}
                            placeholder="Consignes particulières du chantier"
                        />
                    )}
                </Container>
            </Container>
            <CustomBottomBar>
                <Button
                    variant="primary"
                    color="marine"
                    size="fullwidth"
                    onClick={handleNext}
                    disabled={!steps[0].isFilled}
                    className="next-button"
                >
                    <Typography intrinsic="h4">Suivant</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
